module.exports = __webpack_public_path__ + "img/onboarding-image2.9b3b84a4.png";